class infoboxFunctions {
    constructor() {
        this.infoBoxEventListener();
        this.tooltipEventListener();
    }

    infoBoxEventListener = () => {
        let openButtton = document.querySelectorAll('tbody .icon-info'),
            closeButtton = document.querySelectorAll('tbody .icon-close'),
            infoBoxes = document.querySelectorAll('table .qm-info-box'),
            filterButtons = document.querySelectorAll('.qm-filter__dropdown');

        Array.from(openButtton).forEach(element => {
            element.addEventListener('click', () => {
                Array.from(closeButtton).forEach(infoBox => {
                    infoBox.parentNode.classList.add("hide");
                });

                Array.from(filterButtons).forEach(button => {
                    button.classList.remove('active');
                })

                if (element.nextElementSibling) {
                    element.nextElementSibling.classList.remove("hide");
                }
            })
        });

        Array.from(closeButtton).forEach(element => {
            element.addEventListener('click', () => {
                element.parentNode.classList.add("hide");
            })
        });

        Array.from(filterButtons).forEach(element => {
           element.addEventListener('click', () => {
               Array.from(infoBoxes).forEach(box => {
                   box.classList.add('hide');
               })
           })
        });
    }

    tooltipEventListener = () => {
        let openButtton = document.querySelectorAll('tbody .icon-info');

        Array.from(openButtton).forEach(element => {
            element.addEventListener('mouseover', () => {
                element.previousElementSibling.classList.remove("hide");
            });

            element.addEventListener('mouseout', () => {
                element.previousElementSibling.classList.add("hide");
            })
        });
    }
}
